export const getUrlInfo = function(keys) {
  if (!keys) {
    return null;
  }
  const url = location.href;
  const index = url.indexOf('?');
  if (index < 0) {
    return null;
  }
  const paramsArr = url.substr(index + 1).split('&');
  let params = {};
  try {
    for (const i in paramsArr) {
      const arr = paramsArr[i].split('=');
      params[arr[0]] = arr[1];
    }
    if (!Array.isArray(keys)) {
      params = params[keys];
    }
    return params;
  } catch (e) {
    // console.log("url解析错误",e);
  }
};



// WEBPACK FOOTER //
// ./src/js/util/getUrlInfo.js